import EllipsisOutlined from '@ant-design/icons/EllipsisOutlined'
import {Modal} from 'antd'
import React from 'react'
import useTranslate from "../../../modules/local/useTranslate";
import {renderIf} from "../../../views/Shared";

export const DrawerPopupDialog = ({
                                      component = <EllipsisOutlined/>,
                                      children,
                                      title,
                                      open,
                                      setVisible,
                                      width,
                                      footer = true,
                                      wrapClassName = '',
                                      ...props
                                  }) => {
    const t = useTranslate();

    // Bỏ useToggle + useEffect sync thừa — dùng thẳng `open` prop từ Toggle cha.
    // Toggle cha (DrawDialog) đã quản lý state, không cần duplicate ở đây.

    return (
        <Modal
            {...props}
            width={width}
            className="custom-modal"
            rootClassName={wrapClassName}
            footer={null}
            destroyOnHidden={true}
            open={open}
            onCancel={() => setVisible(false)}
            title={title}>

            {/* Bỏ DelayRender — children đã guard bằng `if (!isToggle) return null` bên trong */}
            {children(open, setVisible)}

            {renderIf(
                footer === true,
                <div
                    onClick={() => setVisible(false)}
                    className="mt-6 p-3 text-right text-sm text-color-300 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </div>
            )}
        </Modal>
    )
}

export default DrawerPopupDialog